// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mw-2";
export var interactiveWrapper = "_mw-0";
export var shippingHoverPreview = "_mw-4";
export var summaryBadgeTrigger = "_mw-1";
export var widgetHoverPreviewList = "_mw-3";
export var widgetPreviewScale = "_mw-5";